/// <reference path="../Dashboard/DashboardEditor.ts" />

namespace Matrix.Dashboards {

    @Serenity.Decorators.registerEditor()
    export class WidgetEditor extends DashboardEditor {

        constructor(container: JQuery, opt: any) {
            super(container, opt);

            this.gridStack.enableMove(false, true);
        }

        protected canAddToCatalog() {
            return false;
        }

        protected canDragWidgets() {
            return false;
        }

        protected canRemoveWidgets() {
            return false;
        }

    }
}